




































































































































































































































































































































import Component, {mixins} from "vue-class-component";
import {IDashboardData} from "@/types/Dashboard.model";
import {ChartOptions, MyOptions} from "@/charts/graphData";
import MobileMixin from "@/mixins/mobileMixin";
import DashboardDesktopGrid from "@/components/dashboard/DashboardDesktopGrid.vue";
import TauxCat from "@/homeGraph/tauxCat.vue";
import TauxCatVendeur from "@/homeGraph/dataDonut.vue";
import {Prop, Watch} from "vue-property-decorator";
import Doughnut from "@/charts/Doughnut.vue";
import TotalBarGraph from "@/homeGraph/totalBarGraph.vue";

@Component({
  components: {
    TotalBarGraph, Doughnut,
    DashboardDesktopGrid,
    TauxCat,
    TauxCatVendeur,
  },
})
export default class HomeDashboardDesktop extends mixins(MobileMixin) {
  @Prop() public dashboardData!: IDashboardData;
  @Prop() public myOptions!: MyOptions;
  @Prop() public isTTC!: boolean;

  private lastEmittedServices: string[] = [];

  public renderIsReady() {
    this.dashboardData.nbFinished++;
    this.$emit("renderFinished");
  }

  public init() {
    this.$emit("init");
  }

  public mounted() {
    // Émettre les services disponibles au montage
    this.emitServices();
  }

  @Watch("dashboardData", { immediate: false, deep: false })
  public onDashboardDataChanged(newData: IDashboardData, oldData: IDashboardData) {
    // Seulement surveiller les changements de services, pas tout l'objet dashboardData
    if (newData && newData.services && this.shouldEmitServices(newData.services)) {
      this.emitServices();
    }
  }

  private shouldEmitServices(currentServices: string[]): boolean {
    // Ne pas émettre si les services n'ont pas changé
    if (!currentServices || currentServices.length === 0) {
      return false;
    }

    // Comparer avec les derniers services émis
    if (this.lastEmittedServices.length === currentServices.length &&
        this.lastEmittedServices.every((service, index) => service === currentServices[index])) {
      return false;
    }

    return true;
  }

  private emitServices() {
    if (this.dashboardData && this.dashboardData.services && this.dashboardData.services.length > 0) {
      // Créer une copie pour éviter les références circulaires
      const servicesToEmit = [...this.dashboardData.services];
      console.log("HomeDashboardDesktop - Emitting services:", servicesToEmit);
      this.lastEmittedServices = [...servicesToEmit];
      this.$emit("services", servicesToEmit);
    }
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get getGlobal(): boolean {
    return this.$store.getters["getGlobal"];
  }

  get reRenderKey(): string {
    const reRender = (this.dashboardData && this.dashboardData.reRender) ? this.dashboardData.reRender.toString() : "default";
    return `${reRender}`;
  }

  get chartLabels(): string[] {
    return (this.dashboardData && this.dashboardData.donutLabels) ? this.dashboardData.donutLabels : [];
  }

  get chartColors(): string[] {
    return (this.dashboardData && this.dashboardData.colors) ? this.dashboardData.colors : [
      "#26A69A", "#1976D2", "#EF5350", "#FFD54F", "#7E57C2",
      "#03C9A9", "#C0392B", "#2574A9", "#6C7A89", "#1EBC61",
      "#BD02B0", "#0057A0", "#1EBC61", "#870000"
    ];
  }
}
